import styled from '@emotion/styled';

export const MainMarketColumnWrapper = styled('div', { label: 'MainMarketColumnWrapper' })`
    display: flex;
    flex-direction: column;
`;

export const MainMarketColumn = styled('div', { label: 'MainMarketColumn' })`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    width: 5.5em;
    min-width: 4.5em;
    text-align: center;

`;

export const MainMarketsColumnTitle = styled('span', { label: 'MainMarketsColumnTitle' })`
    position: relative;
    font-size: 10px;
    white-space: break-spaces;
    border-left: 1px solid #dbe1de;
    border-right: 1px solid #dbe1dc;
    margin-bottom: 3px;
    margin-right: -1px;
    line-height: 1.2em;
    height: 42px;
    min-width: 4.5em;
    text-align: center;
    padding: 1px 0 6px;
`;

export const MainMarketsTable = styled('div', { label: 'MainMarketsTable' })`
    flex: 1 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    align-content: space-between;
    overflow: auto;
    font-size: 0.85em;
`;
